import { toCivil } from '@/features/envelope/window';

export function monthFromCivil(civil: string): { year: number; monthIndex: number } {
  return { year: Number(civil.slice(0, 4)), monthIndex: Number(civil.slice(5, 7)) - 1 };
}

export function monthStart(year: number, monthIndex: number): string {
  return toCivil(new Date(year, monthIndex, 1));
}

export function monthEnd(year: number, monthIndex: number): string {
  return toCivil(new Date(year, monthIndex + 1, 0));
}

export function addMonths(
  year: number,
  monthIndex: number,
  delta: number,
): {
  year: number;
  monthIndex: number;
} {
  const d = new Date(year, monthIndex + delta, 1);
  return { year: d.getFullYear(), monthIndex: d.getMonth() };
}

export function calendarWindow(year: number, monthIndex: number): { from: string; to: string } {
  return { from: monthStart(year, monthIndex), to: monthEnd(year, monthIndex) };
}
